import { pushDataObject } from 'scripts/utils/data-layer'

import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

import { getShipmentMessage } from 'catalog/utils/shipments-dictionary'
import { SHIPMENTS_ERROR_STATUS } from 'catalog/utils/constants'

export const pushDataLayer = (
  postalCode,
  region,
  shipment,
  errorStatus,
  selectedSeller
) => {
  const { modality, cost, deadline } = shipment || {}
  const { shop, price } = selectedSeller || {}

  const getDataLayerShipmentMessage = () => {
    if (errorStatus && errorStatus !== SHIPMENTS_ERROR_STATUS.differentRegion) {
      return 'Não foi possível calcular o frete'
    }

    if (!shipment) {
      return 'Frete não disponível para este vendedor'
    }

    const { deadlineMessage } = getShipmentMessage(modality, deadline)

    return `${formatPriceToBRL(cost)} - ${deadlineMessage.prefix} ${
      deadlineMessage.main
    } - ${modality}`
  }

  const regionName = `${region.city} - ${region.stateCode}`
  const shipmentMessage = getDataLayerShipmentMessage()
  const priceTo = `${price.to.integers.replace(/\./g, '')}.${price.to.decimals}`

  const eventParams = {
    event: 'calcule-seu-frete',
    CEP: postalCode,
    CidadeEstado: regionName,
    FreteEcommerce: shipmentMessage,
    Seller: shop.name,
    PrecoProduto: priceTo
  }

  pushDataObject(eventParams)
}
